import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Locale } from '../../../types/locale';
import { DEFAULTS_EN_REASONS, DEFAULT_ES_REASONS } from '../../../domain/tickets';

export const useTravelReasons = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const getTravelReasonsByLocale = (locale: Locale) => {
    switch (locale) {
      case 'es':
        return DEFAULT_ES_REASONS;
      case 'en':
        return DEFAULTS_EN_REASONS;
      default:
        return DEFAULT_ES_REASONS;
    }
  };

  return { travelReasons: getTravelReasonsByLocale(language as Locale) };
};
